export const DOCUMENTATION_LINKS = {
  measuringTTITimes: 'https://shopify.github.io/react-native-performance/fundamentals/measuring-render-times',
  measuringRerenderTimes:
    'https://shopify.github.io/react-native-performance/fundamentals/measuring-render-times#3-measuring-screen-re-render-times',
};
